module.exports = __webpack_public_path__ + "static/media/naija.2dd83a77.svg";